export default "__VITE_ASSET__iuHaHpM8__"